import { Component, ViewChild } from '@angular/core';
import { ModalComponent } from '../../components/modal/modal.component';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { AuthService } from '../../services/auth.service';
import { ProfileService } from '../../services/profile.service';
import { ToastService } from '../../components/toast/toast.service';

@Component({
  selector: 'lowy-edit-display-name',
  template: `
  <lowy-modal #modal>
    <div class="form">
      <div class="headline">Edit Display Name</div>
      <div class="subheading">Your display name will be used in data activity feeds as well as any reasearch group you join</div>
      <div class="seperator"></div>
      <form [formGroup]="editNameForm" (ngSubmit)="save()">
        <mat-form-field>
          <input matInput placeholder="Display name" formControlName="displayName" type="text">
        </mat-form-field>
        <span class="input-error-message" *ngIf="editNameForm.invalid">
        Display name must be no longer than 36 characters and can contain only letters</span>
      </form>
      <div class="seperator"></div>
      <div class="button-row">
        <span (click)="cancel()">cancel</span>
        <span (click)="editNameForm.valid && save()" [ngClass]="{disabled: editNameForm.invalid}">save</span>
      </div>
    </div>
  </lowy-modal>
  `,
  providers: [ ProfileService ]
})
export class EditDisplayNameComponent {
  editNameForm: FormGroup;

  @ViewChild('modal') modal: ModalComponent;

  constructor(private formBuilder: FormBuilder, private profileService: ProfileService, private toastService: ToastService) {
    this.buildForm();
  }

  public open() {
    this.modal.open();
  }

  async buildForm() {
    this.editNameForm = this.formBuilder.group({
      displayName: ['', Validators.compose([Validators.required, Validators.minLength(1), Validators.maxLength(36),
        Validators.pattern('[A-Za-z ]+')])]
    });

    const displayName = await this.profileService.getName();
    this.editNameForm.controls['displayName'].setValue(displayName);
  }

  async save() {
    try {
      await this.profileService.updateName(this.editNameForm.value.displayName);
      this.modal.close();
      this.toastService.throwToast('Display name change successful');
    }
    catch (err) {
      this.modal.close();
      this.toastService.throwToast('Error changing name: ' + err);
    }
  }

  cancel() {
    this.modal.close();
    this.buildForm();
  }
}



// WEBPACK FOOTER //
// ./src/app/home/header/edit-display-name-modal.component.ts